import { FormModel } from '@alfresco/adf-core';
import {
  Component,
  DestroyRef,
  inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import { EditorService, FormComponent } from '@alfresco/adf-process-services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'wk-forms',
  styleUrls: ['./wk-forms.component.scss'],
  templateUrl: './wk-forms.component.html',
  standalone: false,
})
export class WkFormsComponent extends FormComponent implements OnChanges {
  protected editorService = inject(EditorService);
  @Input() hideOnChange: boolean;
  @Input() mandatoryFieldsForRendering: string[];
  @Input() templateForm: any;
  private readonly wkDestroyRef = inject(DestroyRef);

  constructor() {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes['templateForm'] && changes['templateForm'].currentValue) {
      this.parseTemplateForm(changes['templateForm'].currentValue);
    }
  }

  getFormDefinitionByFormId(formId: number) {
    this.editorService
      .getFormDefinitionById(formId)
      .pipe(takeUntilDestroyed(this.wkDestroyRef))
      .subscribe({
        next: (form) => this.parseTemplateForm(form),
        error: (error) => {
          this.handleError(error);
        },
      });
  }

  protected parseTemplateForm(form: any) {
    this.formName = form.name;
    const parsedForm = this.parseForm(form);
    if (this.mandatoryFieldsPresent(parsedForm)) {
      this.form = parsedForm;
      this.visibilityService.refreshVisibility(this.form);
      this.form.validateForm();
      this.onFormLoaded(this.form);
    } else {
      this.handleError('APP.TEMPLATE_DOCUMENT.MANDATORY_FIELD_MISSING');
    }
  }

  protected mandatoryFieldsPresent(parsedForm: FormModel): boolean {
    if (this.mandatoryFieldsForRendering) {
      return this.mandatoryFieldsForRendering.some((ele: string) =>
        parsedForm.getFieldById(ele)
      );
    }
    return true;
  }
}
